<!-- FILE GENERATED BY packages/components/design-tokens/build-scripts/generate-icons.js DO NOT CHANGE -->

<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    data-token-name="IconPhoneHorisontal_16"
    viewBox="0 0 16 16"
    aria-hidden="true"
>
    <g clip-path="url(#IconPhoneHorisontal_16__a)">
        <path
            fill="currentColor"
            d="M.956 8.718c-.21-.75-.02-1.611.505-2.306 1.01-1.338 3.239-2.125 6.64-2.125 4.158 0 5.906 1.155 6.64 2.125.527.694.716 1.556.506 2.306a1.13 1.13 0 0 1-1.37.796l-2.439-.61a1.136 1.136 0 0 1-.862-1.103l-.012-.87a10.378 10.378 0 0 0-2.462-.273c-.833-.001-1.63.076-2.436.232l-.038.917c.001.517-.353.972-.861 1.099l-2.438.61c-.602.148-1.205-.201-1.373-.798Z"
        />
    </g>
    <defs>
        <clipPath id="IconPhoneHorisontal_16__a">
            <path fill="currentColor" d="M0 0h16v16H0z" />
        </clipPath>
    </defs>
</svg>
